module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAGFBMVEUcICv////f4OIeIi3a290rLjkoKzW4ubxmqHGoAAAAVElEQVQoz2NgGGqA2QBNwEgZTYGiEKoSI0FBZVQFIo4oSowEHViQlQAVMDAgKwEqYGBAUgJWgKwErABZSaEIhHYUh+oIcoAwmFShKkxhhgUM5tAGALQuB+YZg1yzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Collapse/assets/arrow.png
// module id = 136
// module chunks = 15